
const TechnicalTrainingSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center">
            Technical Training
          </h2>
          
          <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
            <p>
              Highly technical courses such as rigging and signaling are taught by our most experienced instructors utilizing proprietary training content developed when the new crane standard was implemented in 2010 and adapted annually ever since. We also provide training on skid steers, backhoes, front-end loaders, and other mechanized equipment so your team can ensure the safe operation of these important construction tools.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechnicalTrainingSection;